"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appSectionOrderDefault = exports.appSectionConfigs = void 0;
var latest_1 = require("./latest");
var participate_1 = require("./participate");
var content_1 = require("./content");
var challenges_goals_1 = require("./challenges-goals");
var conversation_channels_1 = require("./conversation-channels");
var following_1 = require("./following");
var home_1 = require("./home");
var places_1 = require("./places");
var platform_1 = require("./platform");
var entities_1 = require("./entities");
var community_1 = require("./community");
var library_1 = require("./library");
exports.appSectionConfigs = {
  home: home_1.home,
  latest: latest_1.latest,
  following: following_1.following,
  conversationChannels: conversation_channels_1.conversationChannels,
  participate: participate_1.participate,
  challengesGoals: challenges_goals_1.challengesGoals,
  community: community_1.community,
  content: content_1.content,
  places: places_1.places,
  library: library_1.library,
  entities: entities_1.entities,
  platform: platform_1.platform
};
exports.appSectionOrderDefault = ['home', 'latest', 'following', 'conversation-channels', 'taxonomies', 'participate', 'community', 'content', 'library', 'places', 'resources', 'entities', 'platform'];